import React from 'react'
import locationsMetadata from './locationsData';
import {Link, Redirect} from 'react-router-dom'
import Helmet from 'react-helmet'
import LocationsView from './LocationsView';
import {siteData} from './locationsData';
import RestaurantMap from './ReataurantMap';
export default function () {
  // console.log("locationsMetadata:", locationsMetadata)
  return(
     <div id="pick-locations" role="main" aria-labelledby="location-header">
  <Helmet>
    <title>{siteData.shortName} | Order Online | Choose Location</title>
  </Helmet>
       

  <style>{`
    a.location {
      border: 1px solid #e0e0e0;
      border-radius: 8px;
      transition: border-color 0.3s ease, transform 0.2s ease;
      padding: 20px;
      cursor: pointer;
      text-decoration: none;
      color: black;
      display: block;
      margin: 1em;
      display: block;
    }
    
    .location:hover {
      border-color: #007bff;
      transform: translateY(-2px);
      box-shadow: 0 4px 8px rgba(0,0,0,0.1);
      color: black;
    }
    
    .location-list-content {
      display: flex;
      gap: 20px;
      align-items: flex-start;
    }
    
    .location-info {
      flex: 1;
    }
    
    .storefront-photo {
      width: 200px;
      height: 150px;
      object-fit: cover;
      border-radius: 8px;
      flex-shrink: 0;
    }
    
    .instruction-text {
      // font-size: 1em;
      text-decoration: underline;
      color: rgb(250, 170, 30);
      font-style: italic;
      margin-top: 16px;
      // text-align: center;
    }
  `}</style>

  <div className="order-header">
      <h1 id="location-header" className="header-text">Choose a {siteData.shortName} location to order online for Pickup or Delivery</h1>

   </div>
          

        <div className="ordering-locations-list" id="ordering-locations-list">{locationsMetadata.map(({id, disabled, buttonLabel, openingDate, label, address, phone, hours, phoneLink, orderLink, className="", external, storefrontPhoto}) => (


            <a 
        key={id} 
        href={orderLink}
        className={" location " + className}
        aria-label={`Order from ${label} location at ${address[0]}, ${address[1]}`}
            >
        <div className="location-list-content">
          <div className="location-info">
            <h3 className="title">{label} Location</h3>

            <div className="address">
              {address[0]} <br/>
              {address[1]}
            </div>
            <div className="phone">
              <a
                className="phone-link"
                href={`tel:${phoneLink}`}
                onClick={(e) => e.stopPropagation()}
              >{phone}</a>
            </div>
            <ul className="hours-of-operation">
              {hours.map((hours) => {
                return (<li key={hours.day}>
                  <span className="">{hours.day}: {hours.hours}</span>
                  {/* <span className="hours">{hours.hours}</span> */}
                </li>)
              })}
            </ul>
            
            {orderLink && (
              <div className="instruction-text">
                order pickup or delivery →
              </div>
            )}
          </div>
          
          {storefrontPhoto && (
            <img 
              src={storefrontPhoto} 
              alt={`${label} storefront`}
              className="storefront-photo"
            />
          )}
        </div>
      </a>
    ))}
  </div>

  <RestaurantMap />
  

</div>  
  )
}
